import { render, staticRenderFns } from "./UserCoursesList.vue?vue&type=template&id=4be1cc7e&"
import script from "./UserCoursesList.vue?vue&type=script&lang=js&"
export * from "./UserCoursesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports